/* ===== i18n ===== */
const I18N = {
  en: {
    toggleLabel: "EN | ES",
    crumbHome: "Home",
    crumbCr: "Costa Rica Shipping",
    crumbStores: "Stores",

    title1: "Ship to Costa Rica —",
    title2: "Door-to-Door",

    intro:
      "Reliable, streamlined shipping — from any U.S. address to our Miami hub, delivered across Costa Rica.",

    ctaShip: "Start a shipment",
    ctaLocker: "Get a Miami locker",
    ctaCalc: "Open calculator",
    ctaStores: "Popular US stores",

    howTitle: "How it works",
    s1: "Shop at any US store.",
    s2: "Ship your items to our Miami address or drop them off:",
    copiedLabel: "Copied!",
    s3: "Email your list (links, sizes/colors, quantities) so we can verify.",
    s4: "We handle customs and transport to Costa Rica.",
    s5: "Door-to-door delivery to your recipient.",

    shopView: "Popular US stores",
    shopEmail: "Email your list",

    whats: "Questions? WhatsApp Oriana Bethencourt T.: ",

    lockTitle: "Miami warehouse / locker",
    lockL1: "Address: 8035 NW 68th St, Miami, FL 33166",
    lockL2: "Drop-off hours: Mon–Fri 9am–5pm",
    lockL3: "We’ll notify you when items arrive and can consolidate by request.",

    faqTitle: "Schedules & transit",
    schedAir: "Air:",
    airSched: "Departures every Friday",
    airTransit: "~7 days in transit",
    schedSea: "Sea:",
    seaSched: "Weekly departures",
    seaTransit: "~7 days in transit",

    q2: "How long does delivery take?",
    a2: "Timing depends on service (air/sea) and customs. We’ll confirm at checkout.",
    q3: "Any packaging tips?",
    a3: "Pack tight, keep invoices handy, and protect fragile items well.",

    sideTitle: "Get started",
    sideP:
      "Start your door-to-door shipping, hassle-free — create your shipment now.",

    estTitle: "Estimate your shipment (CR)",
    uLb: "lb/in",
    uKg: "kg/cm",
    fMode: "Mode",
    mAir: "Air (weight vs volume)",
    mSea: "Sea (cubic feet)",
    fWeight: "Weight",
    fL: "Length",
    fW: "Width",
    fH: "Height",
    fIns: "Insurance",
    btnCalc: "Calculate",
    estDisclaimer:
      "This is an estimate and may change. Duties, taxes, and certain fees are not included.",
    
    fine1:
  "Air pricing: $7.50/lb (chargeable = higher of actual vs volumetric). Minimum: $35.",
    fine2:
      "Volumetric weight: L×W×H ÷ 166 (inches) · L×W×H ÷ 5000 (cm → kg → lb).",
    fine3:
      "Sea pricing: $30 per cubic foot. Volume = L×W×H ÷ 1728 (in³) · L×W×H ÷ 28316.8 (cm³).",
    
      totalLabel: "Estimated total",

    followTitle: "FOLLOW US ON",
    companyTitle: "COMPANY",
    legalTitle: "LEGAL INFO",
    lnkAbout: "About Us",
    lnkServices: "Services",
    lnkBlog: "Blog",
    lnkTerms: "Terms of Service",
    lnkPrivacy: "Privacy Policy",
    lnkRefunds: "Refund Policy",
    copyright:
      "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
  },

  es: {
    toggleLabel: "ES | EN",
    crumbHome: "Inicio",
    crumbCr: "Envíos a Costa Rica",
    crumbStores: "Tiendas",

    title1: "Envíos a Costa Rica —",
    title2: "Puerta a Puerta",

    intro:
      "Envíos confiables y sin complicaciones — desde cualquier parte de EE. UU. a nuestro centro en Miami, entregado a cualquier destino en Costa Rica.",

    ctaShip: "Crear un envío",
    ctaLocker: "Obtener casillero en Miami",
    ctaCalc: "Abrir calculadora",
    ctaStores: "Tiendas populares de EE. UU.",

    howTitle: "Cómo funciona",
    s1: "Compra en cualquier tienda de EE. UU.",
    s2: "Envía tus artículos a nuestra dirección en Miami o entrégalos en persona:",
    copiedLabel: "¡Copiado!",
    s3: "Envíanos tu lista por email (enlaces, tallas/colores, cantidades) para verificar.",
    s4: "Nosotros gestionamos aduana y el transporte a Costa Rica.",
    s5: "Entrega puerta a puerta al destinatario.",

    shopView: "Tiendas populares de EE. UU.",
    shopEmail: "Envíanos tu lista",

    whats: "¿Dudas? WhatsApp Oriana Bethencourt T.: ",

    lockTitle: "Bodega / casillero en Miami",
    lockL1: "Dirección: 8035 NW 68th St, Miami, FL 33166",
    lockL2: "Horario: Lun–Vie 9am–5pm",
    lockL3: "Te avisamos cuando llegue y podemos consolidar a pedido.",

    faqTitle: "Salidas y tránsito",
    schedAir: "Aéreo:",
    airSched: "Salidas todos los viernes",
    airTransit: "~7 días en tránsito",
    schedSea: "Marítimo:",
    seaSched: "Salidas semanales",
    seaTransit: "~7 días en tránsito",

    q2: "¿Cuánto tarda la entrega?",
    a2: "Depende del servicio (aéreo/marítimo) y de aduanas. Confirmamos al pagar.",
    q3: "¿Consejos de empaque?",
    a3: "Empaca ajustado, guarda las facturas y protege bien los artículos frágiles.",

    sideTitle: "Comenzar",
    sideP:
      "Comience sus envíos puerta a puerta, sin complicaciones — cree su envío ahora.",

    estTitle: "Calcula tu envío (CR)",
    uLb: "lb/pulg",
    uKg: "kg/cm",
    fMode: "Servicio",
    mAir: "Aéreo (peso vs volumétrico)",
    mSea: "Marítimo (pies cúbicos)",
    fWeight: "Peso",
    fL: "Largo",
    fW: "Ancho",
    fH: "Alto",
    fIns: "Seguro",
    btnCalc: "Calcular",
    estDisclaimer:
      "Este es un estimado y puede cambiar. No incluye aranceles, impuestos u otros cargos.",
    
    fine1:
  "Tarifa aérea: $7.50/lb (se cobra el mayor entre peso real y volumétrico). Mínimo: $35.",
    fine2:
      "Peso volumétrico: L×W×H ÷ 166 (pulgadas) · L×W×H ÷ 5000 (cm → kg → lb).",
    fine3:
      "Tarifa marítima: $30 por pie cúbico. Volumen = L×W×H ÷ 1728 (pulg³) · L×W×H ÷ 28316.8 (cm³).",
    
      totalLabel: "Total estimado",

    followTitle: "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle: "INFO LEGAL",
    lnkAbout: "Quiénes somos",
    lnkServices: "Servicios",
    lnkBlog: "Blog",
    lnkTerms: "Términos del servicio",
    lnkPrivacy: "Política de privacidad",
    lnkRefunds: "Política de reembolsos",
    copyright:
      "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
  },
};

function applyLang(l) {
  const d = I18N[l] || I18N.en;

  document.title =
    l === "es"
      ? "FHL GO — Envíos a Costa Rica"
      : "FHL GO — Ship to Costa Rica";

  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (d[key] !== undefined) {
      el.textContent = d[key];
    }
  });

  const toggle = document.getElementById("lang");
  if (toggle) toggle.textContent = d.toggleLabel;

  // update mode select text
  const modeSel = document.getElementById("mode");
  if (modeSel && modeSel.options.length >= 2) {
    modeSel.options[0].text = d.mAir;
    modeSel.options[1].text = d.mSea;
  }

  const disc = document.querySelector(".est-muted");
  if (disc && d.estDisclaimer) disc.textContent = d.estDisclaimer;

  localStorage.setItem("fhl_lang", l);
}

// init language + toggle
(function () {
  const current = localStorage.getItem("fhl_lang") || "en";
  applyLang(current);

  const btn = document.getElementById("lang");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const now = localStorage.getItem("fhl_lang") || "en";
    const next = now === "en" ? "es" : "en";
    applyLang(next);
  });
})();

/* Reveal-on-scroll */
(function () {
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
    return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
  );

  document.querySelectorAll("[data-reveal]").forEach((n) => io.observe(n));
})();

/* ===== Calculator — Costa Rica =====
   Air: $7.5/lb chargeable (max(actual lb, volumetric lb)); minimum $35
   Volumetric (in):  L×W×H / 166
   Volumetric (cm):  L×W×H / 5000  → kg → lb
   Sea: $30 per cubic foot
   ft³ (in): L×W×H / 1728
   ft³ (cm): L×W×H / 28316.8      */

const RATES_CR = {
  air_perLb: 7.5,
  air_min: 35,
  sea_perCubicFt: 30,
  dimDivIn: 166,
  dimDivCm: 5000,
  in3_per_ft3: 1728,
  cm3_per_ft3: 28316.8,
};

(function () {
  const $ = (id) => document.getElementById(id);
  const btn = $("calcBtn");
  const out = $("estOut");
  const total = $("estTotal");
  const box = document.querySelector(".est-result");

  if (!btn || !out || !total) return;

  const KG_TO_LB = 2.20462262;

  function unit() {
    return (
      document.querySelector('input[name="unitW"]:checked')?.value || "lb"
    );
  }

  btn.addEventListener("click", (e) => {
    e.preventDefault();

    const isLb = unit() === "lb";
    const modeSel = $("mode");
    const mode = modeSel ? modeSel.value : "air";

    const w = parseFloat($("w")?.value || "0") || 0;
    const L = parseFloat($("l")?.value || "0") || 0;
    const W = parseFloat($("w2")?.value || "0") || 0;
    const H = parseFloat($("h")?.value || "0") || 0;

    const lang = localStorage.getItem("fhl_lang") || "en";
    const dict = I18N[lang] || I18N.en;

    let est = 0;
    const lines = [];

    if (mode === "air") {
      // actual weight → lb
      const actualLb = isLb ? w : w * KG_TO_LB;

      // volumetric weight → lb
      let volLb = 0;
      if (L > 0 && W > 0 && H > 0) {
        if (isLb) {
          volLb = (L * W * H) / RATES_CR.dimDivIn;
        } else {
          const kgVol = (L * W * H) / RATES_CR.dimDivCm;
          volLb = kgVol * KG_TO_LB;
        }
      }

      const chargeable = Math.max(actualLb, volLb);
      est = chargeable * RATES_CR.air_perLb;
      if (est < RATES_CR.air_min) est = RATES_CR.air_min;

      if (lang === "es") {
        lines.push(
          `AÉREO · Peso real: <strong>${actualLb.toFixed(
            2
          )} lb</strong> · Peso volumétrico: <strong>${volLb.toFixed(
            2
          )} lb</strong>`
        );
        lines.push(
          `Peso cobrable: <strong>${chargeable.toFixed(
            2
          )} lb</strong> × US$ ${RATES_CR.air_perLb.toFixed(
            2
          )}/lb (mínimo US$ ${RATES_CR.air_min.toFixed(2)})`
        );
        lines.push(
          `Fórmula volumétrica: L×W×H ÷ ${
            isLb ? RATES_CR.dimDivIn : RATES_CR.dimDivCm
          } (${isLb ? "pulgadas" : "cm"})`
        );
      } else {
        lines.push(
          `AIR · Actual weight: <strong>${actualLb.toFixed(
            2
          )} lb</strong> · Volumetric weight: <strong>${volLb.toFixed(
            2
          )} lb</strong>`
        );
        lines.push(
          `Chargeable: <strong>${chargeable.toFixed(
            2
          )} lb</strong> × US$ ${RATES_CR.air_perLb.toFixed(
            2
          )}/lb (minimum US$ ${RATES_CR.air_min.toFixed(2)})`
        );
        lines.push(
          `Volumetric formula: L×W×H ÷ ${
            isLb ? RATES_CR.dimDivIn : RATES_CR.dimDivCm
          } (${isLb ? "inches" : "cm"})`
        );
      }
    } else {
      // SEA
      let ft3 = 0;
      if (L > 0 && W > 0 && H > 0) {
        if (isLb) {
          ft3 = (L * W * H) / RATES_CR.in3_per_ft3;
        } else {
          ft3 = (L * W * H) / RATES_CR.cm3_per_ft3;
        }
      }
      est = ft3 * RATES_CR.sea_perCubicFt;

      if (lang === "es") {
        lines.push(
          `MARÍTIMO · Volumen: <strong>${ft3.toFixed(
            3
          )} ft³</strong> × US$ ${RATES_CR.sea_perCubicFt.toFixed(2)}/ft³`
        );
        lines.push(
          `Fórmula: L×W×H ÷ ${
            isLb ? RATES_CR.in3_per_ft3 : RATES_CR.cm3_per_ft3
          } (${isLb ? "pulgadas³" : "cm³"})`
        );
      } else {
        lines.push(
          `SEA · Volume: <strong>${ft3.toFixed(
            3
          )} ft³</strong> × US$ ${RATES_CR.sea_perCubicFt.toFixed(2)}/ft³`
        );
        lines.push(
          `Formula: L×W×H ÷ ${
            isLb ? RATES_CR.in3_per_ft3 : RATES_CR.cm3_per_ft3
          } (${isLb ? "in³" : "cm³"})`
        );
      }
    }

    // show orange box if present
    if (box) box.style.display = "block";

    out.style.display = "block";
    total.style.display = "block";

    out.innerHTML = lines.join("<br>");
    total.textContent = `${dict.totalLabel}: $${est.toFixed(2)}`;
  });
})();

/* ========== Copy Miami address helper ========== */
window.copyFHLAddress = function () {
  const icon = document.getElementById("fhlgo-copy-address");
  const confirm = document.getElementById("copy-confirm");
  if (!icon || !confirm) return;

  const text = icon.dataset.address || "8035 NE 68th St, Miami, FL 33166";

  // Try modern clipboard API first
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(
      () => {
        confirm.style.display = "inline";
        setTimeout(() => {
          confirm.style.display = "none";
        }, 1500);
      },
      () => fallbackCopy(text, confirm)
    );
  } else {
    fallbackCopy(text, confirm);
  }
};

function fallbackCopy(text, confirmEl) {
  const temp = document.createElement("textarea");
  temp.value = text;
  temp.style.position = "fixed";
  temp.style.opacity = "0";
  document.body.appendChild(temp);
  temp.select();
  try {
    document.execCommand("copy");
  } catch (e) {}
  document.body.removeChild(temp);

  confirmEl.style.display = "inline";
  setTimeout(() => {
    confirmEl.style.display = "none";
  }, 1500);
}